import React, { ButtonHTMLAttributes, ReactNode } from "react";
import { LoadingSpinner } from "@/components/shared";
import classes from "classnames/bind";
import styles from "./Button.module.sass";

type Props = {
  variant?: "primary" | "ghost" | "neutral" | "invisible";
  size?: "sm" | "md" | "lg";
  onClick?: React.MouseEventHandler | ((...args: unknown[]) => void);
  children: ReactNode;
  classnames?: string;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  fullWidth?: boolean;
  disabled?: boolean;
  dataQa?: string;
  isLoading?: boolean;
};

export const Button = ({
  size = "sm",
  onClick = () => {},
  children,
  variant = "primary",
  classnames,
  type = "submit",
  fullWidth,
  disabled,
  dataQa = "",
  isLoading = false,
}: Props): JSX.Element => {
  const cx = classes.bind(styles);

  const buttonClass = cx(
    "B2B-Button",
    `B2B-Button--${variant}`,
    `B2B-Button--${size}`,
    { "full-width": fullWidth },
    classnames
  );

  return (
    <button className={buttonClass} type={type} onClick={(e) => onClick(e)} disabled={disabled} data-qa={dataQa}>
      {isLoading && <LoadingSpinner customClass={styles.loading} />}
      {children}
    </button>
  );
};
